export default __webpack_public_path__ + "static/media/add_moments.dc16f4c6.svg";